module.exports = __webpack_public_path__ + "static/media/stam.573681e0.svg";